import { render } from "./CompanyExpenses.vue?vue&type=template&id=7b2ed7e3&scoped=true&ts=true"
import script from "./CompanyExpenses.vue?vue&type=script&lang=ts"
export * from "./CompanyExpenses.vue?vue&type=script&lang=ts"

import "./CompanyExpenses.vue?vue&type=style&index=0&id=7b2ed7e3&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2ed7e3"]])

export default __exports__